import { memo, useMemo } from "react";
import styles from "./Spinner.module.css";

interface SpinnerProps {
	overlay?: boolean;
	className?: string;
	size?: number;
}

const Spinner = memo(({ overlay = false, className = "", size = 100 }: SpinnerProps) => {
	const spinnerStyle = useMemo(() => {
		const borderWidth = Math.max(2, Math.floor(size * 0.04));
		return {
			width: size,
			height: size,
			borderWidth,
		};
	}, [size]);

	const spinnerContent = (
		<div className={`${styles.spinnerContainer} ${className}`}>
			<div className={styles.spinner} role="progressbar" aria-label="Loading" style={spinnerStyle} />
		</div>
	);

	if (overlay) {
		return <div className={styles.spinnerOverlay}>{spinnerContent}</div>;
	}

	return spinnerContent;
});

Spinner.displayName = "Spinner";

export default Spinner;
